import React, { useState } from "react";
import "./Header.css";
import logo from "../../assets/imgs/logo.png";
import profile from "../../assets/imgs/me.jpg";

import { FaHome, FaRegBell, FaRegEdit } from "react-icons/fa";
import { BsBookmarks, BsFileText } from "react-icons/bs";
import { Link, NavLink } from "react-router-dom";

export default function Header({ savedToList, email, firstName, ownSaved }) {
  let [modalShow, setModalShow] = useState(false);

  const showModalHandler = () => {
    setModalShow(true);
  };

  const modalHideHandler = () => {
    setModalShow(false);
  };
  return (
    <div className="header">
      <Link to="bosh-sahifa">
        <img src={logo} alt="img" />
      </Link>

      <ul className="ul">
        <NavLink to="bosh-sahifa">
          <FaHome className="home" />
        </NavLink>

        <Link to="news">
          <div className="book-flex1">
            <FaRegBell />
            <div className="absolute1"></div>
          </div>
        </Link>

        <NavLink to="saqlangan">
          <div className="book-flex">
            <BsBookmarks />
            <div className="absolute">{savedToList.length}</div>
          </div>
        </NavLink>

        <NavLink to="my-saved">
          <div className="book-flex">
            <div className="absolute">{ownSaved.length}</div>
            <BsFileText />
          </div>
        </NavLink>
        <hr />

        <NavLink to="new-story">
          <FaRegEdit className="edit" />
        </NavLink>
      </ul>

      <div className="profile" onClick={showModalHandler}>
        <img src={profile} alt="img" />
        <div
          className={`profile-modal ${
            modalShow ? "profile-modal-show" : "profile-modal"
          }`}
        >
          <ul>
            <Link to="/">
              <li>Sign Out</li>
            </Link>
            <li>Refine Recommendation</li>
            <li>Manage Publication</li>
            <li>Stats</li>
            <li>Settings</li>
            <div className="just-flex">
              <img src={profile} alt="profile" />
              <div className="right-div">
                <p>{firstName}</p>
                <p>{email}</p>
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div
        onClick={modalHideHandler}
        className={`Mod-back ${modalShow ? "Mod-back-show" : "Mod-back"}`}
      ></div>
    </div>
  );
}
